import React from 'react';

export class Footer extends React.Component {

	render() {
		return (
		<div className="footer">

			<div className="footer-row">
				<div className="column-1">
					<a href="/about.html">About</a><br />
					<a href="/partner.html">Business Partners</a><br />
					<a href="/customer.html">Customers</a><br />
					<a href="/pricing.html">Pricing</a><br />
					<a href="/contact.html">Contact</a><br />
				</div>
			</div>
			<div className="copyright">
				2018 rewardeclub
			</div>
		</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/Footer.js